import { capitalize } from 'lib';
import { useTranslation } from 'react-i18next';
import { EVENT_STYLES, formatAmount, formatDate } from './helpers';

const TimelineEvent = ({ event, isLast }) => {
  const { t } = useTranslation();
  const style = EVENT_STYLES[event.eventType] || EVENT_STYLES.checkout_initiated;
  const amount = formatAmount(event.amount, event.currency);

  const eventTypeLabel = t(
    `subscriptions.admin.subscribers.detail.eventTypes.${event.eventType}`,
    {
      defaultValue: event.eventType
    }
  );

  return (
    <div className="flex gap-3.5 relative">
      <div className="flex flex-col items-center" style={{ width: 32 }}>
        <div
          className="w-[11px] h-[11px] rounded-full border-[2.5px] flex-shrink-0 mt-[3px]"
          style={{ borderColor: style.color, backgroundColor: '#fff' }}
        />
        {!isLast && (
          <div className="w-px flex-1 bg-[#e5e7eb] mt-0.5" style={{ minHeight: 16 }} />
        )}
      </div>

      <div className={`flex-1 min-w-0 ${isLast ? 'pb-1' : 'pb-5'}`}>
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <p className="text-[13px] font-semibold text-[#2d3643] leading-snug">
              {eventTypeLabel}
            </p>
            <p className="text-[11px] text-[#8993a4] mt-0.5">
              {event.occurredAt
                ? new Date(event.occurredAt).toLocaleString()
                : '-'}
              {event.provider && (
                <span className="text-[#b5bdc8]"> · {capitalize(event.provider)}</span>
              )}
            </p>
          </div>
          {amount && (
            <span
              className={`text-[13px] font-semibold tabular-nums whitespace-nowrap rounded-md px-2 py-0.5 border ${style.bg} ${style.border}`}
              style={{ color: style.color }}
            >
              {amount}
            </span>
          )}
        </div>
        {event.periodStart && event.periodEnd && (
          <p className="text-[11px] text-[#b5bdc8] mt-1.5">
            {t('subscriptions.admin.subscribers.detail.period')}{' '}
            {formatDate(event.periodStart)} — {formatDate(event.periodEnd)}
          </p>
        )}
      </div>
    </div>
  );
};

export default TimelineEvent;
